<div class="message message__user" fxLayoutAlign="flex-end center" *ngIf="fromUser">
    <app-edit class="message__edit" *ngIf="edition" (edit)="edit.emit()"></app-edit>
    <div class="primary-bg message__balloon">
        <p *ngIf="!file" [innerHtml]="body | safeHtml"></p>
        <div class="message__file" *ngIf="file">
            <pdf-viewer
                *ngIf="file.type === 'application/pdf'; else showImage"
                [src]="body"
                [render-text]="false"
                [original-size]="false"
                [show-all]="false"
                [page]="1"
                [zoom]="1"
                [zoom-scale]="'page-width'"
            >
            </pdf-viewer>
            <ng-template #showImage>
                <div #imageElement fxFlex="100%" fxLayoutAlign="center"></div>
            </ng-template>
        </div>
    </div>
</div>
<div class="message message__bot" [ngClass]="{ 'message__bot--edit' : body && edition }" fxLayoutAlign="stretch flex-end" *ngIf="!fromUser">
    <span class="material-icons bot__icon">face</span>
    <div fxLayoutAlign="flex-start center">
        <div class="message__balloon"
            *ngIf="body"
            [ngClass]="{
                'message__balloon--warning' : warning,
                'message__balloon--break__strong': breakStrong
            }"
            [innerHtml]="body | safeHtml">
        </div>
        <app-edit class="message__edit" *ngIf="body && edition" (edit)="edit.emit()"></app-edit>
        <div class="message__balloon" *ngIf="!body">
            <p class="bot__typing">
                <span class="typing__dots">
                    <span class="typing__dot"></span>
                    <span class="typing__dot"></span>
                    <span class="typing__dot"></span>
                </span>
                Digitando
            </p>
        </div>
    </div>
</div>
